import { Brand, createBranded } from '@deltasierra/type-utilities';

export type BuilderTemplateId = Brand<number, 'BuilderTemplateId'>;
export const BuilderTemplateId = createBranded<BuilderTemplateId>();
